import frMessages from 'ra-language-french';

const fr = {
    ...frMessages,
    resources: {
        events: {
            name: 'Événement |||| Événements',
            fields: {
                title: 'Titre',
                category: 'Catégorie',
                country_id: 'Pays',
                region_id: 'Région',
                start_at: 'Date début',
                end_at: 'Date fin',
                online: 'En ligne',
                on_site: 'Sur place',
                lat: 'Latitude',
                lng: 'Longitude',
                address: 'Adresse',
                organization_name: 'Nom organisation',
                organization_website: 'Site web organisation',
                organization_contact_info: 'Info contact organisation',
                intro: 'Introduction',
                content: 'Contenu',
                status: 'Statut',
                published: 'Publié'
            }
        },
        account: {
            fields: {
                firstname: 'Prénom',
                lastname: 'Nom',
                password: 'Mot de passe',
                job_title: 'Intitulé de poste',
                organization_name: 'Nom organisation',
                organization_address: 'Adresse organisation',
                organization_website: 'Site web organisation',
                organization_contact_name: 'Nom contact organisation',
                organization_contact_email: 'E-mail contact organisation',
            }
        }
    },
    'Total': 'Total',
    'My upcoming event(s)': 'Mes événements à venir',
    'Join us and create an event': 'Rejoignez-nous et proposez un événement',
    'Once your event is created the Europe Members team will review your event. If everything is in order, you will be prompted by e-mail and you will be able to publish your event.': 'Une fois votre événement créé, l\'équipe d\'Europe Remembers l\'examinera. Si tout est en ordre, vous serez invité par e-mail à publier votre événement.',
    'Create event': 'Créer un événement',
    'Search': 'Recherche',
    'Country': 'Pays',
    'Region': 'Région',
    'Published': 'Publié',
    'Online': 'En ligne',
    'On site': 'Sur place',
    'Draft': 'Brouillon',
    'Review': 'En révision',
    'Accepted': 'Accepté',
    'Refused': 'Refusé',
    'Commemoration': 'Commémoration',
    'Conference': 'Conférence',
    'Festival': 'Festival',
    'Guided tour': 'Visite guidée',
    'Exhibition': 'Exposition',
    'Music-Theater': 'Musique et théâtre',
    'Other': 'Autre',
    'Ask for review': 'Envoyer pour validation',
    'Do you want to ask a review for the event': 'Voulez-vous soumettre votre événement pour validation avant publication',
    'Unpublish': 'Dépublier',
    'Do you want to unpublish the event': 'Voulez-vous dépublier l\'événement',
    'Event published': 'Événement publié',
    'Event unpublished': 'Événement non publié',
    'Publish': 'Publier',
    'Do you want to publish the event': 'Voulez-vous publier l\'événement',
    'Summary': 'Résumé',
    'Translations': 'Traductions',
    'Pictures': 'Images',
    'Title': 'Titre',
    'Intro': 'Introduction',
    'Content': 'Contenu principal',
    'Picture': 'Image',
    'Description': 'Description',
    'Copyright': null,
    'Featured': 'Image principale (utilisée pour les miniatures)',
    'Account': 'Compte',
    'Account updated': 'Compte mis à jour',
    'Forgot password?': 'Mot de passe oublié ?',
    'Forgot password': 'Mot de passe oublié',
    'An email has been sent': 'Un e-mail a été envoyé',
    'Email': 'E-mail',
    'Reset password': 'Réinitialiser le mot de passe',
    'Main picture': 'Image principale (utilisée pour les miniatures)',
    'Default language': 'Langue par défaut',
    'Event website': 'Site web événement',
    'Europe Remembers : How to create an event ?': 'L\'Europe se souvient : Comment créer un événement ?',
    'Turn on subtitles (CC) to get instructions in your language.': 'Activez les sous-titres (CC) pour obtenir des instructions dans votre langue.',
    'Contribute to the project!': 'Contribuez \nau projet !',
    'Europe Remembers aims to give visibility to your events and is free to use ! However we need your contributions to help us maintain and keep this platform running.': 'Europe Remembers vise à donner de la visibilité à vos événements et son utilisation est gratuite ! Cependant, nous avons besoin de vos contributions pour nous aider à maintenir et à faire fonctionner cette plateforme.'
};

export default fr;